import $ from 'jquery';

export default class Navigation {
  constructor(instance) {
    this.$el = $(instance.el);
    $('[data-dropdown-toggle]').on('click.navigation', event => this.toggleNavigation(event));
    $('[data-dropdown-toggle]').on('keydown.navigation', event => this.toggleNavigationByKey(event));

    this.$dropdowns = this.$el.find('.has-dropdown');
    this.dropdownToggle = '[data-dropdown-toggle]';

    this.$el.on('click.navigation', (event) => {
      if (!$(event.target).closest('.navigation').length) {
        $('.navigation .open').removeClass('open');
      }
    });

    this.$dropdowns.hover((event) => {
      const $target = $(event.currentTarget);
      this.closeSiblingMenus($target);
    });

    this.$el.on('focus.navigation', '.has-dropdown > .header-navigation-link', (event) => {
      const $target = $(event.currentTarget).parent('li');
      this.closeTierMenus($target);
    });
  }

  closeSiblingMenus($targetLi) {
    const $siblingMenuParents = $targetLi.siblings('.open');
    this.closeMenus($siblingMenuParents);
  }

  closeTierMenus($target) {
    const $openMenus = $target.parent().find('.open');

    if (!$openMenus.length) { return; }

    this.closeMenus($openMenus);
  }

  closeMenus($menusParents) {
    $menusParents.each((index, menuParent) => {
      const $menuParent = $(menuParent);
      const $toggle = $menuParent.closest(this.dropdownToggle);

      $menuParent.removeClass('open');
      this.toggleMenuButton($toggle, false);
    });
  }

  toggleMenuButton($button, state) {
    $button.attr('aria-expanded', state);
  }

  toggleNavigationByKey(event) {
    if (event.keyCode !== 13) { return; }
    this.toggleNavigation(event);
  }

  toggleNavigation(event) {
    const $toggle = $(event.currentTarget);
    const $parent = $toggle.parent('.has-dropdown');
    const menuIsOpen = $parent.hasClass('open');

    this.closeSiblingMenus($parent);
    this.toggleMenuButton($toggle, !menuIsOpen);

    event.preventDefault();
    $parent.toggleClass('open');
  }

  unload() {
    $('[data-dropdown-toggle]').off('.navigation');
    this.$el.off('.navigation');
  }
}
